import { FC } from 'react';
import { IoBagHandleOutline } from 'react-icons/io5';

import { Group, Text } from '@mantine/core';

import { IntlHelpers } from 'helpers/IntlHelpers';

import type { ComponentPricing, Manufacturer } from '@/payload-types';

const ComponentOverviewHitDistributorPrice: FC<{
    distributorPrice: ComponentPricing;
}> = ({ distributorPrice }) => {
    const distributor = distributorPrice.distributor as Manufacturer | undefined;

    if (!distributorPrice.price) {
        return null;
    }

    return (
        <Group gap={4} wrap="nowrap">
            <IoBagHandleOutline size={12} />
            <Text fz="sm" fw={600}>
                {IntlHelpers.formatPriceShort(distributorPrice.price)}
                {distributor?.name && ` at ${distributor.name}`}
                {distributorPrice.leadTime && (
                    <Text span inherit fw={400} c="dimmed">
                        {' · '}
                        {distributorPrice.leadTime}
                    </Text>
                )}
            </Text>
        </Group>
    );
};

export { ComponentOverviewHitDistributorPrice };
